// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    drawerContents: {
      width: 500,
      height: '100%',
      background: '#eee7',
      overflow: 'auto',
    },
  }),
);

export default useStyles;
